import React from "react";
import { useHistory } from "react-router";

import cx from "classnames";

import { dispatchAnalyticsTrack } from "~/lib/segment";
import { isNative } from "~/lib/utils";
import { Button } from "~/ui";
import { ButtonLink } from "~/ui/legacyFellowIndex";

import paywallStyles from "~/billing/css/Billing.module.css";
import noteCardStyles from "~/stream/css/NoteCard.module.css";
import noteHeaderStyles from "~/stream/NoteHeader/NoteHeader.module.css";

import styles from "./css/NoteBlur.module.css";

const paywalledNoteClassname = cx(
	paywallStyles.paywalledNote,
	noteHeaderStyles.paywalledNote,
	noteCardStyles.paywalledNote,
);

export function NoteBlur({ children, inviteId }: React.PropsWithChildren<{ inviteId: string }>): React.ReactElement {
	const history = useHistory();
	const inviteSenderName = window.INITIAL_STATE.invite_sender_name;

	const [isBlurHidden, setIsBlurHidden] = React.useState(false);
	const onViewStaticNote = React.useCallback(() => {
		dispatchAnalyticsTrack("NoteBlur Action Taken", { action: "view_only" });
		setIsBlurHidden(true);
	}, []);

	const encodedStreamInviteId = encodeURIComponent(inviteId);
	const streamInviteNextUrl = encodeURIComponent(`/ext/notes/invite/${encodedStreamInviteId}/consume/`);
	const streamInviteParams = `?next=${streamInviteNextUrl}&stream_invite=${encodedStreamInviteId}`;

	const signupLink = `/auth/signup/${streamInviteParams}`;

	const onContinue = React.useCallback(() => {
		dispatchAnalyticsTrack("NoteBlur Action Taken", { action: "continue_to_signup" });
		history.push(signupLink);
	}, [history, signupLink]);

	if (isBlurHidden) {
		return <>{children}</>;
	}

	return (
		<div className={paywallStyles.paywallWrapper}>
			<div className={paywallStyles.paywallContainer}>
				<div className={cx(paywallStyles.paywallContent, paywallStyles.lifted)}>
					<div>
						<div className={paywallStyles.paywallHeading}>
							<strong className="text-underlay text-underlay-orange">{inviteSenderName}</strong> wants to share notes
							with you for your meeting
						</div>
						<span className={paywallStyles.paywallText}>
							Collaborate on the agenda, take notes in real time, and so much more.
							<br />
							<strong>It only takes a minute to get started.</strong>
						</span>
					</div>
					{!isNative && (
						<div className={styles.controls}>
							<Button size="wide" variant="primary" className={paywallStyles.paywallUpgradeButton} onClick={onContinue}>
								Continue
							</Button>
							<ButtonLink className={styles.viewOnly} onClick={onViewStaticNote}>
								or use view-only mode
							</ButtonLink>
						</div>
					)}
				</div>
			</div>
			<div className={paywalledNoteClassname}>{children}</div>
		</div>
	);
}
